import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginModule } from '../login/login.module';
import { HeaderModule } from '../header/header.module';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UserManagementModule } from './user-management/user-management.module';
import { ImpersonateComponent } from './impersonate/impersonate.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CompanyManagementModule } from './company-management/company-management.module';



@NgModule({
  declarations: [ImpersonateComponent, AdminDashboardComponent],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    HeaderModule,
    LoginModule,
    UserManagementModule,
    CompanyManagementModule
  ]
})
export class AdminModule { }
